var a={Currency:"currency",Entity:"entity",Language:"language",Account:"account"},e={Tiny:"tiny",Small:"small",Default:"default",Large:"large"};export{e as AvatarSize,a as AvatarType};
//# sourceMappingURL=types.js.map
